module.exports = __webpack_public_path__ + "img/interaction_very_bad.40376984.svg";